import { IOrgAddress } from '../../../types/addressBook';
import {
  ICreateSendRecipient,
  TAddressMode,
  TClaimLinkMode,
  TMultiKitAddressMode,
} from '../../../types/createSendRecipients';

export const SET_CS_ADDRESS_MODE = 'SET_CS_ADDRESS_MODE';
export const SET_CS_CLAIM_LINK_MODE = 'SET_CS_CLAIM_LINK_MODE';
export const SET_CS_MULTI_KIT_ADDRESS_MODE = 'SET_CS_MULTI_KIT_ADDRESS_MODE';
export const CS_ADD_RECIPIENT = 'CS_ADD_RECIPIENT';
export const CS_UPDATE_RECIPIENT = 'CS_UPDATE_RECIPIENT';
export const CS_REMOVE_RECIPIENT = 'CS_REMOVE_RECIPIENT';
export const CS_CLEAR_RECIPIENTS = 'CS_CLEAR_RECIPIENTS';
export const CS_SET_RECIPIENTS = 'CS_SET_RECIPIENTS';
export const SET_CS_OVERRIDE_ADDRESS = 'SET_CS_OVERRIDE_ADDRESS';
export const SET_CS_ONE_TIME_ADDRESS = 'SET_CS_ONE_TIME_ADDRESS';
export const SET_CS_CLAIM_ADDRESS_IDS = 'SET_CS_CLAIM_ADDRESS_IDS';
export const RESET_CS_RECIPIENTS = 'RESET_CS_RECIPIENTS';

export const setAddressMode = (payload: TAddressMode) => ({
  type: SET_CS_ADDRESS_MODE,
  payload,
});

export const setClaimLinkMode = (payload: TClaimLinkMode) => ({
  type: SET_CS_CLAIM_LINK_MODE,
  payload,
});

export const setMultiKitAddressMode = (payload: TMultiKitAddressMode) => ({
  type: SET_CS_MULTI_KIT_ADDRESS_MODE,
  payload,
});

export const addRecipient = (payload: ICreateSendRecipient) => ({
  type: CS_ADD_RECIPIENT,
  payload,
});

export const updateRecipient = (payload: { uid: string; patch: Partial<ICreateSendRecipient> }) => ({
  type: CS_UPDATE_RECIPIENT,
  payload,
});

export const removeRecipient = (payload: string) => ({
  type: CS_REMOVE_RECIPIENT,
  payload,
});

export const clearRecipients = () => ({
  type: CS_CLEAR_RECIPIENTS,
});

export const setRecipients = (payload: ICreateSendRecipient[]) => ({
  type: CS_SET_RECIPIENTS,
  payload,
});

export const setOverrideAddress = (payload: IOrgAddress | null) => ({
  type: SET_CS_OVERRIDE_ADDRESS,
  payload,
});

export const setOneTimeAddress = (payload: IOrgAddress | null) => ({
  type: SET_CS_ONE_TIME_ADDRESS,
  payload,
});

export const setClaimAddressIds = (payload: string[]) => ({
  type: SET_CS_CLAIM_ADDRESS_IDS,
  payload,
});

export const resetRecipients = () => ({
  type: RESET_CS_RECIPIENTS,
});
